import React from 'react';
import FeedApi from '~/screens/ApiScreen/FeedApi';

const ApiScreen: React.FC = () => <FeedApi />;

export default ApiScreen;
